import { useWorkflowsTable } from '../hooks/useWorkflowsTable'

import { Box } from '@chakra-ui/react'

import {
  TABLE_HEIGHT,
  TABLE_MAX_WIDTH,
  Table,
  TableBody,
  TablePagination,
  TableRow,
} from '@hivewatch/dark'

import { WorkflowsTableHeader } from './WorkflowsTableHeader'
import { WorkflowsTableRow } from './WorkflowsTableRow'
import { WorkflowsTableToolbar } from './WorkflowsTableToolbar'

const ROW_HEIGHT = 56
const HEADER_HEIGHT = 40
const PAGINATION_HEIGHT = 56
const TABS_HEIGHT = 69

interface WorkflowsTableIProps {
  onRowClick?: (versionId: string) => void
}

export const WorkflowsTable = ({ onRowClick }: WorkflowsTableIProps = {}) => {
  const {
    colorScheme,
    columns,
    filter,
    isLoading,
    setFilter,
    tableData,
    total,
    pageIndex,
    setPageIndex,
    pageSize,
    pageCount,
    sortableColumns,
    handleSortChange,
    handlePageSizeChange,
  } = useWorkflowsTable()

  const tableHeight = `min(calc(${TABLE_HEIGHT} - ${TABS_HEIGHT}px), ${
    HEADER_HEIGHT +
    (tableData.length || (isLoading ? pageSize : 1)) * ROW_HEIGHT +
    PAGINATION_HEIGHT
  }px)`

  return (
    <>
      <WorkflowsTableToolbar
        colorScheme={colorScheme}
        filter={filter}
        setFilter={setFilter}
      />
      <Table
        colorScheme={colorScheme}
        height={tableHeight}
        maxWidth={TABLE_MAX_WIDTH}
        onSortChange={handleSortChange}
        sortableColumns={sortableColumns}
      >
        <WorkflowsTableHeader columns={columns} />
        <TableBody isLoading={isLoading} skeletonRowCount={pageSize}>
          {!isLoading && tableData.length === 0 ? (
            <TableRow>
              <Box
                alignItems='center'
                display='flex'
                flex='1'
                height='56px'
                justifyContent='center'
              >
                <Box color='text.secondary' fontSize='14px'>
                  No workflows found
                </Box>
              </Box>
            </TableRow>
          ) : null}
          {tableData.map((row) => (
            <WorkflowsTableRow
              columns={columns}
              key={row.id}
              onClick={onRowClick ? () => onRowClick(row.id) : undefined}
              row={row}
            />
          ))}
        </TableBody>
        <TablePagination
          onPageChange={setPageIndex}
          onPageSizeChange={handlePageSizeChange}
          pageCount={pageCount}
          pageIndex={pageIndex}
          pageSize={pageSize}
          pageSizeLabel='Workflows per page:'
          total={total}
        />
      </Table>
    </>
  )
}
